import { ReactElement, useState } from "react";
import { useGenerateAiSurveyResponsesMutation } from "../../redux/survey/survey.endpoints";
import { RadioButtonGrid, RadioButtonGridType } from "../radio-button/radio-button";
import { ReactComponent as Check } from "../../assets/icons-redesign/check.svg";

interface AiSampleSizeRadioButtonProps {
  readonly extSurveyId: string;
  readonly zeroDisabled: boolean;
  readonly sampleSizes: number[];
  onSubmit?: () => void;
}

const AiSampleSizeRadioButton = ({ zeroDisabled, extSurveyId, sampleSizes, onSubmit }: AiSampleSizeRadioButtonProps): ReactElement => {
  const [createSurveyResponses] = useGenerateAiSurveyResponsesMutation();
  const [maxCompletes, setMaxCompletes] = useState('0');
  const [isLoading, setIsLoading] = useState(false);
  const radioButtons = sampleSizes.map(size => {
    const value = String(size);
    return { label: value, value };
  });

  const handleSubmit = () => {
    setIsLoading(true);
    const result = createSurveyResponses({
      ext_survey_id: extSurveyId,
      max_completes: maxCompletes,
    });

    setTimeout(() => {
      setIsLoading(false);
      onSubmit && onSubmit();
    }, 3000);
  };

  const iconStroke = 'white';
  const isDisabled = maxCompletes === '0' || maxCompletes === null || maxCompletes === undefined;

  return (
    <>
      {isLoading && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-40 z-50"
        >
          <div className="bg-white p-6 rounded-md shadow-md flex items-center">
            {/* Spinner */}
            <div className="h-8 w-8 border-4 border-blue-500 border-t-transparent border-solid rounded-full animate-spin" />
            <p className="text-lg font-medium ml-3">
              Assembling request for AI Panelists...
            </p>
          </div>
        </div>
      )}
      <RadioButtonGrid
        buttons={radioButtons}
        disabledForZero={zeroDisabled}
        extSurveyId={extSurveyId}
        initialValue={maxCompletes}
        onClick={(val) => setMaxCompletes(val)}
        title='One-time AI Panelists'
        type={RadioButtonGridType.AI}
      />
      <div className='w-full'>
        <button
          disabled={isDisabled}
          className={`bg-purple-500 text-white px-3 py-2 rounded-xl mr-2 mt-1 w-full ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={handleSubmit}
        >
          <div className='w-full flex items-center justify-center gap-1.5 text-sm md:text-base font-medium mx-auto'>
            <Check
              width='12px'
              height='12px'
              stroke={iconStroke}
            />
            Trigger Now
          </div>
        </button>
      </div>
    </>
  );
};

export default AiSampleSizeRadioButton;
